import { combineReducers } from 'redux';
import { deleteJiraInitiativesUnlinkIssueSlice } from './@async/delete';
import { getInitiativesJiraIssueSlice } from './@async/get';
import { initiativesJiraIssueAddSyncSlice } from './@sync/add';
import { initiativesJiraIssueRemoveSyncSlice } from './@sync/remove';
import { initiativesJiraIssueUpdateSlice } from './@sync/update';
import { putJiraInitiativesLinkIssueSlice } from './@async/put';
import { combineAllWatchers, joinReducers } from '@sonar-software/xuder';
import { jiraInitiativesSyncReducers, jiraInitiativesSyncWatchers } from './sync-jira';

export const jiraInitiativesReducers = combineReducers({
	delete: deleteJiraInitiativesUnlinkIssueSlice.asyncReducers,
	get: joinReducers(
		[
			getInitiativesJiraIssueSlice.asyncReducers,
			initiativesJiraIssueAddSyncSlice.syncReducer,
			initiativesJiraIssueRemoveSyncSlice.syncReducer,
			initiativesJiraIssueUpdateSlice.syncReducer
		],
		getInitiativesJiraIssueSlice.asyncState
	),
	put: putJiraInitiativesLinkIssueSlice.asyncReducers,
	sync: jiraInitiativesSyncReducers
});

export const jiraInitiativesWatchers = combineAllWatchers([
	deleteJiraInitiativesUnlinkIssueSlice.asyncWatchers,
	getInitiativesJiraIssueSlice.asyncWatchers,
	jiraInitiativesSyncWatchers,
	putJiraInitiativesLinkIssueSlice.asyncWatchers
]);
